export interface Tag {
  color?: TagColor;
  icon: TagIcon;
  textKey: string;
}

export enum TagColor {
  BENEFITS = 'benefits',
}

export enum TagIcon {
  BENEFITS = 'present',
}
